import { jwtDecode } from './node_modules-jwt-decode-build-esm-index.js';
import { util } from './src-utils-miaw-common.js';
import { DISPLAY_NAME } from './src-config-app-config.js';

const transformStartChatApiResponse = (response) => {
  const message = {
    id: util.generateUUID(),
    messageContent: response.data.response.messages,
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    type: "chatbot",
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: false,
    showFeedback: false
  };
  const token = response.token;
  const decoded = getChatbotSessionInfo(token);
  return {
    message,
    sessionId: decoded.sessionId || "",
    discussionId: decoded.discussionId || "",
    chatbotToken: token
  };
};
const getChatbotSessionInfo = (token) => {
  if (typeof window === "undefined") {
    console.warn("getChatbotSessionInfo is not available in this environment.");
    return {};
  }
  if (!token) return {};
  const decoded = jwtDecode(token);
  return {
    sessionId: decoded.session_id,
    discussionId: decoded.discussion_id
  };
};

export { getChatbotSessionInfo, transformStartChatApiResponse };
//# sourceMappingURL=src-utils-chatbot-api-utils.js.map
